var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_221_348)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_221_348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 192,
    height: 192
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.759 0H17.2414C9.92837 0 4 5.92837 4 13.2414V178.759C4 186.072 9.92837 192 17.2414 192H182.759C190.072 192 196 186.072 196 178.759V13.2414C196 5.92837 190.072 0 182.759 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_221_348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.759 0H17.2414C9.92837 0 4 5.92837 4 13.2414V178.759C4 186.072 9.92837 192 17.2414 192H182.759C190.072 192 196 186.072 196 178.759V13.2414C196 5.92837 190.072 0 182.759 0Z",
    stroke: "#75F0B5",
    strokeWidth: 30
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.037 79.8548C154.744 73.4966 146.263 75.7048 135.947 86.3882C119.542 103.376 95.1555 111.705 91.3605 101.612C88.5059 94.0221 98.0423 74.3522 111.573 59.9176C121.764 49.0489 123.02 44.2366 117.04 38.973C108.957 31.86 97.8751 39.3478 97.0061 52.5116C95.9565 68.3901 79.632 93.9014 71.232 92.7901C61.5651 91.509 57.9479 72.5436 64.2945 56.4188C70.5507 40.5251 60.8311 27.1391 50.8156 37.8555C46.2347 42.7574 46.1113 45.4526 49.9421 56.9136C55.3625 73.1319 53.9571 80.7533 41.4285 103.06C32.2122 119.47 32.7182 126.407 44.1615 140.589C54.8779 153.871 66.4419 156.738 86.2807 151.037C103.507 146.087 113.523 147.018 134.95 155.562C147.767 160.674 153.122 160.055 155.289 153.214C157.688 145.644 150.694 138.863 143.291 141.584C133.036 145.35 104.039 138.537 101.491 131.761C97.6882 121.648 125.857 102.186 146.665 100.551C163.133 99.2574 170.187 89.1006 161.037 79.8548Z",
    fill: "#75F0B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_221_348",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_221_348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_221_348",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4605dbb28b3e76d3a3b70c3f7d864d22.svg";
export { ForwardRef as ReactComponent };